document.addEventListener("recommendationsLoaded", (e) => {
    const productRecommendations = document.querySelector(".product-recommendations");
    const complementaryProducts = document.querySelector('.f-complementary-products');
    const productGridItems = document.querySelector("product-grid-container");
    const megaMenus = document.querySelectorAll(".f-site-nav__dropdown--mega");
    const featuredCollectionSection = document.querySelector(".featured-collection");
    
    if ( productRecommendations != null ) {
      productRecommendations.removeEventListener("click", changeProductImage);
      productRecommendations.addEventListener("click", changeProductImage);
    }
    
    if ( productGridItems != null ) {
      productGridItems.removeEventListener("click", changeProductImage);
      productGridItems.addEventListener("click", changeProductImage);
    }

    if ( featuredCollectionSection != null ) {
      featuredCollectionSection.removeEventListener("click", changeProductImage);
      featuredCollectionSection.addEventListener("click", changeProductImage);
    };

    if ( complementaryProducts != null ) {
      complementaryProducts.removeEventListener("click", changeProductImage);
      complementaryProducts.addEventListener("click", changeProductImage);
    }

    for ( let i = 0; i < megaMenus.length; i++ ) {
      megaMenus[i].removeEventListener("click", changeProductImage);
      megaMenus[i].addEventListener("click", changeProductImage);
    }

    // time issue selecting buttons need to wait a bit before running init
    if ( window.useNewQuickaddSystem ) {
      selectFirstOptionForEachProduct();
    }

    function changeProductImage( event ) {
      const swatch = event.target.closest(".swatch-list-item");
      let useNewSystem = window.useNewQuickaddSystem || false;

      //let isARealSwatch = event.target.getAttribute('data-recommendation');

      //if ( swatch != null && isARealSwatch) {
      if ( swatch != null ) {
        const productWrapper = swatch.closest(".product-card__wrapper");
        if ( productWrapper ) {
          const allSwatches = productWrapper.querySelectorAll('.swatch-list-item');
          
          if ( useNewSystem ) {
            for ( let i = 0; i < allSwatches.length; i++ ) {
              allSwatches[i].classList.remove('active-color');
              if ( swatch.getAttribute('data-base') == allSwatches[i].getAttribute('data-base') ) {
                allSwatches[i].classList.add('active-color');
              }
            }
          }

          const productLink = productWrapper.querySelector(".product-card__link")
          const imageWrapper = productWrapper.querySelector(".product-card__image-wrapper")
          const mainImage = imageWrapper.querySelector(".product-card__image--main")
          const secondImageHold = imageWrapper.querySelector(".product-card__image--second")
          const image = mainImage.querySelector("img")
          let secondImage = null;
          if ( secondImageHold ) {
            secondImage = secondImageHold.querySelector("img");
          }

          // const originalImageUrl = image.src
          // const originalImageSrcSet = image.srcset
          // const originalAlt = image.alt

          const newImageUrl = swatch.dataset.imageUrl
          const newImageSrcset = swatch.dataset.srcset
          const newImageAlt = swatch.dataset.alt

          const secondImageUrl = swatch.dataset.secondImageUrl
          const secondImageSrcset = swatch.dataset.secondSrcset
          const secondImageAlt = swatch.dataset.secondAlt

          if ( swatch.classList.contains("mobile-swatch") ) {
            // const newHref = swatch.dataset.href
            // let clickCount = parseInt(swatch.dataset.clicks)

            // productLink.href = newHref
            // image.src = newImageUrl
            // image.srcset = newImageSrcset
            // image.alt = newImageAlt
            if ( useNewSystem == true ) {
                clickCount = 0;
                swatch.dataset.clicks = 0;
            }

            // if ( clickCount > 0 ) {
            //   const mobileDiv = swatch.querySelector(".mobile-div")
            //   const aTag = document.createElement("a")
            //   aTag.setAttribute("href", newHref)
            //   mobileDiv.parentNode.insertBefore(aTag, mobileDiv)
            //   aTag.appendChild(mobileDiv)
            //   swatch.dataset.clicks = 0
            // } else {
            //   clickCount++
            //   swatch.dataset.clicks = clickCount
            //   productLink.href = newHref
            //   image.src = newImageUrl
            //   image.srcset = newImageSrcset
            //   image.alt = newImageAlt
            // }

          } else {
            if ( secondImage ) {
              
              secondImage.src = secondImageUrl
              secondImage.srcset = secondImageSrcset
              secondImage.alt = secondImageAlt
              
              // image.src = secondImageUrl
              // image.srcset = secondImageSrcset
              // image.alt = secondAlt
            }
          }
    
          // image.src = newImageUrl
          // image.srcset = newImageSrcset
          // image.alt = newImageAlt
          
          if ( window.useNewQuickaddSystem ) {
            const relatedQuickAddElement = productWrapper.querySelector('product-quick-add');
            if ( relatedQuickAddElement != null && relatedQuickAddElement.updateSizesAvailable) {
              relatedQuickAddElement.updateSizesAvailable();
            }

            const file = swatch.getAttribute('data-base');
            runImageSliderUpdates( productWrapper , file );
          }
        }
      }
    }
    

    function initViewMoreSwatches() {
      const buttons = document.querySelectorAll( '[data-view-more-options]' );
      for ( let i = 0; i < buttons.length; i++ ) {
        buttons[i].removeEventListener( 'click' , viewMoreSwatches );
        buttons[i].addEventListener( 'click' , viewMoreSwatches );
      }
  
      return;
    }
  
    function viewMoreSwatches( event ) {
      const target = event.target;
      const listParent = target.closest('.view-more-in-list');
      const swatchList = target.closest( '.swatch-list' );
  
      if ( swatchList != null ) {
        const hiddenRows = swatchList.querySelectorAll( '.swatch-list-item.hidden' );
        for ( let i = 0; i < hiddenRows.length; i++ ) {
          hiddenRows[i].classList.remove('hidden');
        }
      }
  
      if ( listParent != null ) {
        listParent.classList.add( 'hidden' );
      }
  
      return;
    }

    function selectFirstOptionForEachProduct() {
      let productGridswatchesToClick = document.querySelectorAll('#product-grid .swatch-list-item.select-on-load');
      let headerSwatchesToClick = document.querySelectorAll('.f-site-nav__dropdown--mega .swatch-list-item.select-on-load');
      let featuredCollectionSwatchesToClick = document.querySelectorAll('.featured-collection .swatch-list-item.select-on-load');
      let productRecommendationsSwatchesToClick = document.querySelectorAll('.product-recommendations .swatch-list-item.select-on-load');
      let complementaryProductsSwatchesToClick = document.querySelectorAll('.f-complementary-products  .swatch-list-item.select-on-load');

      if (productGridswatchesToClick.length <= 0) {
        productGridswatchesToClick = document.querySelectorAll('#product-grid .swatch-list-item:first-of-type');
      }

      if (headerSwatchesToClick.length <= 0) {
        headerSwatchesToClick = document.querySelectorAll('.f-site-nav__dropdown--mega .swatch-list-item:first-of-type');
      }
     
      if (featuredCollectionSwatchesToClick.length <= 0) {
        featuredCollectionSwatchesToClick = document.querySelectorAll('.featured-collection .swatch-list-item:first-of-type');
      }
      
      if (productRecommendationsSwatchesToClick.length <= 0) {
        productRecommendationsSwatchesToClick = document.querySelectorAll('.product-recommendations .swatch-list-item:first-of-type');
      }
      
      if (complementaryProductsSwatchesToClick.length <= 0) {
        complementaryProductsSwatchesToClick = document.querySelectorAll('.f-complementary-products  .swatch-list-item:first-of-type');
      }
      
      const swatchesToClick = [ 
        ...productGridswatchesToClick, 
        ...headerSwatchesToClick, 
        ...featuredCollectionSwatchesToClick, 
        ...productRecommendationsSwatchesToClick,
        ...complementaryProductsSwatchesToClick
      ];
      
      for ( let i = 0; i < swatchesToClick.length; i++ ) {
        swatchesToClick[i].click();
      }
    }

    function runImageSliderUpdates( productWrapper , fileName ) {
      if ( productWrapper ) {
        const sliderEl = productWrapper.querySelector('product-card-slider');

        if ( sliderEl && sliderEl.setSliderIndexByColorClicked ) {
          sliderEl.setSliderIndexByColorClicked( fileName );
        }
      }
    }
});